import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { mainStore } from './store/store';
import App from './components/app/App.react';
export var store = mainStore();
createRoot(document.getElementById('root')).render(/*#__PURE__*/React.createElement(Provider, {
  store: store
}, /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(App, null))));